<template>
  <v-col>
    <DocumentsHeader
      :uploadfn="addedDocument"
      :prependMenu="menuItems"
      :onsave="saveReorderDocuments"
      @clear="clearHeader"
      @toggleDelete="showChecks = !showChecks"
      @setmode="setmode"
      :confirmDelete="deleteDocuments"
    />

    <div v-if="documentList.length > 0">
      <draggable v-model="documentList" handle=".handle">
        <div v-for="doc in documentList" :key="doc.id" class="d-flex">
          <v-col v-if="showDrag" class="handle d-flex align-center" style="max-width: 50px">
            <v-icon class="white--text">drag_indicator</v-icon>
          </v-col>

          <v-col>
            <CheckboxWrapper
              :value="doc.id"
              :show-check="showChecks"
              @toggle="selectFileDelete"
            >
              <a class="docdownload" :href="getLink(doc)" @click="(e) => openPdf(e, doc)">
                <a-card nopad class="d-flex hover justify-space-between">
                  <div class="d-flex align-center">
                    <span class="subtitle-2 pa-3">{{ doc.display_name || doc.name }}</span>
                    <v-btn class="editbtn" icon small @click="(e) => editDocument(e, doc)">
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </div>
                  <div class="caption pa-3">
                    <span>{{ doc.user_name }}</span>
                    <span class="mx-2">|</span>
                    <span>{{ formatDate(doc.uploaded_date) }}</span>
                  </div>
                </a-card>
              </a>
            </CheckboxWrapper>
          </v-col>
        </div>
      </draggable>
    </div>

    <edit-document-dialog v-model="editDialog" :editData="editFocus" @update="updateDocument" />
    <d-no-display v-if="documentList.length === 0" label="(No documents to display)" />
  </v-col>
</template>

<script>
import draggable from "vuedraggable";
import dateFormat from "@/services/format";
import { DocumentsHeader } from "@/modules/media.documents";

export default {
  components: {
    draggable,
    DocumentsHeader,
  },
  data() {
    return {
      menuItems: [
        {
          title: "Reorder",
          showMode: "SAVE",
        },
      ],
      showChecks: false,
      showDrag: false,
      checkedItems: [],
      documentList: [],

      // Edit Dialog
      editDialog: false,
      editFocus: {},
    };
  },
  computed: {
    supplierId() {
      return this.$store.getters["SupplierStore/id"];
    },
    hostName() {
      return this.$store.getters["host"];
    },
  },
  methods: {
    formatDate(date) {
      return date ? dateFormat.formatDate(dateFormat.convertDate(date)) : "(unknown)";
    },
    setDefaultSorted(documentList) {
      let result = documentList
        .filter((item) => item.order !== null)
        .sort((first, second) => first.order - second.order);

      let noOrderAssigned = documentList.filter((item) => item.order === null);

      return [...result, ...noOrderAssigned];
    },
    setmode(mode) {
      this.showChecks = mode === "DELETE";
      this.showDrag = mode === "SAVE";
    },
    // DELETE STUFF
    clearHeader() {
      this.showChecks = false;
      this.showDrag = false;
      this.checkedItems = [];
    },
    selectFileDelete({ check, value }) {
      // Add to delete list group if checked
      // Remove from list group if not checked
      if (check) {
        this.checkedItems.push(value);
      } else {
        var index = this.checkedItems.findIndex((x) => x.id === value);
        this.checkedItems.splice(index, 1);
      }
    },
    deleteDocuments() {
      return this.$store
        .dispatch("DocumentStore/deleteDocumentList", this.checkedItems)
        .then((v) => {
          this.$root.$success("Deleted documents");
          var vm = this;
          this.documentList = this.documentList.filter(function (item) {
            return vm.checkedItems.indexOf(item.id) === -1;
          });
          this.clearHeader();
        })
        .catch((err) => this.$root.$error(err));
    },

    // REORDER
    saveReorderDocuments() {
      this.$root.$loading.open("Saving order of documents...");
      return this.$store
        .dispatch("DocumentStore/reorderDocuments", {
          supplierId: this.supplierId,
          updatedDocumentList: this.documentList,
        })
        .then(() => {
          this.$root.$loading.end();
          this.$root.$success("Document Order Updated");
        })
        .catch(this.$root.$error);
    },

    // ADD
    addedDocument(docList) {
      return Promise.all(
        docList.map((doc) => {
          return this.uploadDocument(doc);
        })
      )
        .then((docBulk) => {
          this.$root.$success(`Uploaded documents`);
          docBulk.forEach((doc) => {
            doc.user_name = this.$store.getters["AccountStore/name"];
            this.documentList.push(doc);
          });
        })
        .catch((err) => this.$root.$error(err));
    },
    uploadDocument(doc) {
      return this.$store.dispatch("StorageStore/uploadFile", { name: doc.name, file: doc.upload }).then((data) => {
        return this.$store.dispatch("DocumentStore/addDocument", {
          origin_id: this.supplierId,
          name: doc.name,
          key: data.key,
        });
      });
    },

    // VIEW
    getLink(doc) {
      return this.$store.getters["host"] + doc.src;
    },
    openPdf(event, doc) {
      if (doc.mimetype.includes("pdf")) {
        event.preventDefault();
        this.$store.dispatch("openPdf", { ...doc, link: this.getLink(doc) });
      }
    },

    // EDIT
    editDocument(event, doc) {
      event.preventDefault();
      event.stopPropagation();
      this.editDialog = true;
      this.editFocus = doc;
    },
    updateDocument(data) {
      let source = this.documentList.find((item) => item.id === data.id);

      this.editDialog = false;
      this.$root.$loading.open("Updating image");
      this.$store
        .dispatch("DocumentStore/updateDocument", {
          ...data,
          old_name: source.display_name,
          dependent_id: this.supplierId,
        })
        .then((v) => {
          source.display_name = data.display_name;
          this.$root.$loading.end();
        })
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    this.$store
      .dispatch("DocumentStore/getDocumentList", this.supplierId)
      .then((list) => {
        this.documentList = this.setDefaultSorted(list);
      })
      .catch((err) => this.$root.$error);
  },
};
</script>

<style lang="scss">
.docdownload {
  .editbtn {
    display: none;
  }

  &:hover {
    .editbtn {
      display: inline-block;
    }
  }
}

.handle {
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>
